import axios from 'axios';

const API_URL = 'https://enviatupaquete-backend-production.up.railway.app/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para agregar el token a todas las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }

    // Manejo de bloqueo, revisión anti-fraude y cuenta sin validar
    const data = error.response?.data;
    if (data && (data.bloqueado === true || data.en_revision === true || data.no_validado === true)) {
      const event = new CustomEvent('cuenta-restringida', {
        detail: {
          mensaje: data.error,
          bloqueado: data.bloqueado || false,
          en_revision: data.en_revision || false,
          no_validado: data.no_validado || false
        }
      });
      window.dispatchEvent(event);
    }

    return Promise.reject(error);
  }
);

export default api;